export default "__VITE_ASSET__NF0W0Guo__"